import React from "react";

const CompanySourceWindow = ({
  isOpen,
  sourceWindowDataset,
  sourceWindowInput,
  sourceWindowError,
  sourceDatasetOptions,
  onClose,
  onDatasetChange,
  onSourceInputChange,
  onSubmit,
}) =>
  isOpen ? (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/72 px-4 py-6 backdrop-blur-sm">
      <button
        type="button"
        aria-label="Close source window"
        className="absolute inset-0 cursor-default"
        onClick={onClose}
      />
      <div className="relative w-full max-w-[min(42rem,calc(100vw-2rem))] rounded-2xl border border-slate-700 bg-[#0d1420] p-5 shadow-[0_24px_70px_rgba(2,6,23,0.72)]">
        <div className="flex items-start justify-between gap-3">
          <div>
            <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500">
              Add Source
            </p>
            <h3 className="mt-1 text-base font-semibold text-slate-50">Link manual source IDs</h3>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-xs font-semibold text-slate-200 transition-colors hover:border-slate-500 hover:text-white"
          >
            Close
          </button>
        </div>

        <div className="mt-4 space-y-3">
          <label className="block">
            <span className="mb-2 block text-xs font-medium uppercase tracking-[0.12em] text-slate-500">
              Dataset
            </span>
            <select
              value={sourceWindowDataset}
              onChange={(event) => onDatasetChange(event.target.value)}
              aria-label="Source dataset"
              className="min-h-[3rem] w-full rounded-2xl border border-slate-700 bg-slate-950/80 px-4 py-3 text-sm text-slate-100 outline-none transition-all focus:border-sky-500/60 focus:ring-2 focus:ring-sky-500/20"
            >
              <option value="">Choose a dataset</option>
              {sourceDatasetOptions.map((dataset) => (
                <option key={dataset.id} value={dataset.id}>
                  {dataset.name}
                </option>
              ))}
            </select>
          </label>

          <label className="block">
            <span className="mb-2 block text-xs font-medium uppercase tracking-[0.12em] text-slate-500">
              Source IDs
            </span>
            <textarea
              value={sourceWindowInput}
              onChange={(event) => onSourceInputChange(event.target.value)}
              aria-label="Source IDs"
              rows={6}
              placeholder="One ID per line, or comma-separated"
              className="min-h-[9rem] w-full rounded-2xl border border-slate-700 bg-slate-950/80 px-4 py-3 text-sm text-slate-100 outline-none transition-all focus:border-sky-500/60 focus:ring-2 focus:ring-sky-500/20"
            />
          </label>

          {sourceWindowError ? (
            <div className="rounded-2xl border border-rose-500/20 bg-rose-500/10 px-4 py-3 text-sm text-rose-100">
              {sourceWindowError}
            </div>
          ) : null}

          <div className="flex justify-end gap-2">
            <button
              type="button"
              onClick={onClose}
              className="rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-xs font-semibold text-slate-200 transition-colors hover:border-slate-500 hover:text-white"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={onSubmit}
              className="rounded-lg border border-cyan-500/40 bg-cyan-500/10 px-3 py-2 text-xs font-semibold text-cyan-100 transition-colors hover:border-cyan-400 hover:text-white"
            >
              Add source
            </button>
          </div>
        </div>
      </div>
    </div>
  ) : null;

export default CompanySourceWindow;
